import * as React from 'react';
import { styles } from './styles';
import { ExitButton } from '..';
import { PopupOnClose } from '../../types';

interface PopupHeaderProps {
  children?: React.ReactNode;
  centered?: boolean;
  onClose: PopupOnClose;
}

export const PopupHeader: React.SFC<PopupHeaderProps> = ({ children, centered, onClose }) => {
  return (
    <div className={styles.container(centered)}>
      {children ? (
        <div>
          {children}
          <ExitButton onClose={onClose} />
        </div>
      ) : (
        <ExitButton onClose={onClose} />
      )}
    </div>
  );
};
